import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e962a76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "add_task",
  style: {"min-height":"580px","max-height":"580px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("积压板材汇总")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("积压木料汇总")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("积压油漆汇总")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "售前-评审 请先看积压库存", -1))
const _hoisted_6 = { style: {"height":"20px"} }

import { ref,onMounted } from 'vue';
	import { xmUser,requestAddTask,xmDetails2 } from '@/api/xmApi';
	import { apiName,requestMyuser } from '@/api/api';
	import { ElMessage } from 'element-plus';
	import {
		requestOverstockList
	} from '@/api/zjhApi';
	import type { UploadUserFile } from 'element-plus'
	
export default /*#__PURE__*/_defineComponent({
  name: 'overstocklist',
  emits: ['cancelTask'],
  setup(__props, { emit }) {

	const List = ref<any[]>([])
	const List1 = ref<any[]>([])
	const List2 = ref<any[]>([])
	
	const api = ref<string>(apiName)
	const jytype=ref<string>(apiName)
	const cancel = () => {
		emit("cancelTask")
	}
	onMounted(()=>{
		loadlist();
		jytype.value='积压板材汇总';
	})
	const loadlist = () => {
			requestOverstockList({
				type1:'积压板材汇总',
			}).then((res:any)=>{
				List.value = res.datalist
			})
			requestOverstockList({
				type1:'积压木料汇总',
			}).then((res:any)=>{
				List1.value = res.datalist
			})
			requestOverstockList({
				type1:'积压油漆汇总',
			}).then((res:any)=>{
				List2.value = res.datalist
			})
		
	}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (jytype.value='积压板材汇总')),
      style: {"margin-top":"10px","margin-bottom":"10px"}
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (jytype.value='积压木料汇总')),
      style: {"margin-top":"10px","margin-bottom":"10px"}
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (jytype.value='积压油漆汇总')),
      style: {"margin-top":"10px","margin-bottom":"10px"}
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (jytype.value=='积压板材汇总')
        ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: List.value,
            "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
            height: "550px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                width: "80",
                label: "序号",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "mc",
                label: "名称",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "dw",
                label: "单位",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "tznum",
                label: "台州数量",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "xznum",
                label: "徐州数量",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "dwpf",
                label: "单位平方",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "yt",
                label: "用途",
                width: "280"
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true),
      (jytype.value=='积压木料汇总')
        ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: List1.value,
            "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
            height: "550px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                width: "80",
                label: "序号",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "mc",
                label: "名称",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "gg",
                label: "规格",
                width: "130"
              }),
              _createVNode(_component_el_table_column, {
                prop: "dw",
                label: "单位",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "tznum",
                label: "台州数量",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "xznum",
                label: "徐州数量",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "bz",
                label: "备注",
                width: "280"
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true),
      (jytype.value=='积压油漆汇总')
        ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 2,
            data: List2.value,
            "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
            height: "550px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                width: "80",
                label: "序号",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "mc",
                label: "名称",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "numkg",
                label: "数量KG",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "gys",
                label: "供应商",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "yt",
                label: "用途",
                width: "180"
              }),
              _createVNode(_component_el_table_column, {
                prop: "colorcode",
                label: "色号",
                width: "180"
              }),
              _createVNode(_component_el_table_column, {
                prop: "colorseries",
                label: "色系",
                width: "180"
              }),
              _createVNode(_component_el_table_column, {
                prop: "pc",
                label: "批次",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "scrq",
                label: "生产日期",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "bz",
                label: "备注",
                width: "180"
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})